import React from "react";
import Button, { ButtonOwnProps } from "@mui/material/Button";

import Modal from "./Modal";

type ConfirmModalProps = React.ComponentProps<typeof Modal> & {
  cancelText?: string;
  confirmText?: string;
  disabled?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  color?: ButtonOwnProps["color"];
};

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  cancelText = "Cancel",
  confirmText = "OK",
  disabled = false,
  onConfirm,
  onCancel,
  color = "primary",
  ...rest
}) => (
  <Modal
    actions={
      <>
        <Button color="inherit" onClick={onCancel} data-testid="cancel-button">
          {cancelText}
        </Button>

        <Button variant="contained" color={color} onClick={onConfirm} data-testid="confirm-button" disabled={disabled}>
          {confirmText}
        </Button>
      </>
    }
    {...rest}
  />
);

export default ConfirmModal;
